module.exports = __webpack_public_path__ + "static/241-2b354150508a4427d0410eecb957461f.jpg";